import { mapState,mapGetters,mapActions,mapMutations } from 'vuex';
import * as neovis from "@MOD/neovis.js/dist/neovis.js";
import NeoVisConfig from '@/configs/NeoVisConfig';

const NeoVis = {

	data: function () {
		return {
			total:null,
			neovis: null,
			show_neovis: false,
			show_loader: true,
			config: null,
			tick: 0, // <----- Very important 1 = start server query 2 = Server query compelted.
			query:"",
			values:{}
		}
	},

	computed: {

		...mapState({
			reports: state => state.reports
		}),

	},

	mounted: function () {
		
		this.neovis = new neovis.default(NeoVisConfig);
		this.show_loader = true;
		this.neovis.render();


	},

	methods: {

		...mapMutations({
			setModules: 'setModules',
			setActiveModule: 'setActiveModule'
		}),

		/**
		 * Value object has attribute
		 */
		 hasValue(value){
		 	return this.values.hasOwnProperty(value);
		 },

		/** 
		 * Aasign active module for form display
		 */
		 setActive(module){

		 	this.show_loader = true;

		 	if(!module){
		 		return this.setActiveModule(module);
		 	}

		 	let value_object = {};

		 	for (var i = module.module.binding.length - 1; i >= 0; i--) {

		 		let iteration = module.module.binding[i]

		 		if( iteration[Object.keys(iteration)[0]] == 'array' ){
		 			value_object[ `tag_${Object.keys(iteration)[0]}` ] = ''
		 			continue;
		 		}

		 		value_object[ Object.keys(iteration)[0] ] = null;

		 	}

		 	this.values[module.module_name] = value_object;
		 	this.setActiveModule(module)


		 },

		/**
		 * Stop NeoVis Physics
		 */
		 stopPhysics(){
		 	this.neovis.stabilize();
		 },

	    /**
	     * Clear NeoVis query
	     */
	     backToSearch() {
	     	
	     	this.show_neovis = false;
	     	this.show_loader = true;
	     	
	     	this.neovis.clearNetwork();
			this.neovis = new neovis.default(NeoVisConfig);
			this.neovis.render();
			this.setActive(false);

	     },

	     /**
	      * Handel after draw
	      */
	      afterDraw(event){

	      	this.tick = 0;
	      	this.$nextTick(() => {

	      		this.total = event.record_count;

	      		if(this.show_loader && this.total > 0 && this.show_neovis){

	      			this.neovis._network.once('afterDrawing', (canvas)=>{
	      				this.show_loader = false;
	      			});

	      		}

	      	});

	      },

	    /**
	     * Draw Selected graph element
	     */
	     draw(done){

	     	this.show_neovis 	= true;
	     	this.show_loader 	= true;


	     	this.$nextTick(() => {

	     		this.neovis.renderWithCypher(this.query);	
	     		this.neovis._events.register("completed",(event)=>{

	     			this.tick++;

	     			if(this.tick > 1 && event.record_count > 0) {
	     				this.afterDraw(event);
	     			};

	     			if(this.tick > 1 && event.record_count <= 0) {
	     				
	     				let message = this.$toasted.show(`Query returned ${event.record_count} results, redirecting back to list.`, { 
							 theme: "toasted-primary", 
							 position: "top-center", 
							 duration : 5000
						});

	     				setTimeout(()=> this.backToSearch(), 500);

	     			};

	     		});


	     	});

	     },

	     assignConfig(config){
	     	this.neovis.reinit(Object.assign(NeoVisConfig,config));
	     },

	    /**
	     * Build query string with binding Bbinding should be prefixed with `:` 
	     * @example `:binding_key` = `binding_value`
	     * @param {String} query
	     * @param {Object} binding
	     *
	     * @return {string}
	     */
	     bind(query,binding={}){

	     	return Object.keys(binding).reduce((prev, current) => {

	     		let iteration = binding[current];

	     		if( Array.isArray(iteration) ){
	     			return prev.replace(new RegExp(`:${current}`, 'g'), JSON.stringify(iteration.map(input => `${input.text}`)));
	     		}

	     		return prev.replace(new RegExp(`:${current}`, 'g'), iteration);

	     	}, query);

	     },

		/**
		 * Prepare Cypher
		 */
		 prepareQuery(query,binding={}){
		 	this.query = this.bind(query,binding);
		 	console.log(this.query);
		 	
		 }

		}

	}

	export default NeoVis;